export default __webpack_public_path__ + "static/media/welcomeStep4.d03a3850.png";